import axios from 'axios';

const apiURL = process.env.REACT_APP_API_URL;

export interface GoNoGoItem {
    goNoGoId: number;
    client: string | null;
    sector: string | null;
    value: number | null;
    location: string | null;
    reference: string | null;
    dueDate: string | null;
    qualityPriceWeight: string | null;
    capacityToBid: boolean | null;
    existingRelationship: boolean | null;
    link: string | null;
    dateOnsite: string | null;
    duration: string | null;
    capacityToDeliver: boolean | null;
    description: string | null;
    status: string | null;
    go: boolean | null;
    clientId: number | null;
    siteId: number | null;
    contactId: number | null;
    enquiryId: number | null;
    clientName: string | null;
    siteName: string | null;
    createDate: string | null;
    modifiedDate: string | null;
    deletedDate: string | null;
    archivedDate: string | null;
    createdByName: string | null;
}

export interface GoNoGoDTO {
    goNoGoId?: number;
    client?: string | null;
    sector?: string | null;
    value?: number | null;
    location?: string | null;
    reference?: string | null;
    dueDate?: string | null;
    qualityPriceWeight?: string | null;
    capacityToBid?: boolean | null;
    existingRelationship?: boolean | null;
    link?: string | null;
    dateOnsite?: string | null;
    duration?: string | null;
    capacityToDeliver?: boolean | null;
    description?: string | null;
    status?: string | null;
    go?: boolean | null;
    clientId?: number | null;
    siteId?: number | null;
    contactId?: number | null;
}

const getConfig = () => {
    const token = localStorage.getItem('authToken');
    const storedApiURL = localStorage.getItem('apiURL');
    const finalApiURL = storedApiURL || apiURL;
    return { token, finalApiURL };
};

export const getGoNoGos = async (includeDeleted = false, includeArchived = false): Promise<GoNoGoItem[]> => {
    const { token, finalApiURL } = getConfig();
    const response = await axios.get(`https://${finalApiURL}/GoNoGo?includeDeleted=${includeDeleted}&includeArchived=${includeArchived}`, {
        headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
};

export const getGoNoGo = async (id: number): Promise<GoNoGoItem> => {
    const { token, finalApiURL } = getConfig();
    const response = await axios.get(`https://${finalApiURL}/GoNoGo/${id}`, {
        headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
};

export const createGoNoGo = async (dto: GoNoGoDTO): Promise<GoNoGoItem> => {
    const { token, finalApiURL } = getConfig();
    const response = await axios.post(`https://${finalApiURL}/GoNoGo`, dto, {
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` }
    });
    return response.data;
};

export const updateGoNoGo = async (id: number, dto: GoNoGoDTO): Promise<GoNoGoItem> => {
    const { token, finalApiURL } = getConfig();
    const response = await axios.put(`https://${finalApiURL}/GoNoGo/${id}`, dto, {
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` }
    });
    return response.data;
};

export const deleteGoNoGo = async (id: number): Promise<void> => {
    const { token, finalApiURL } = getConfig();
    await axios.delete(`https://${finalApiURL}/GoNoGo/${id}`, {
        headers: { Authorization: `Bearer ${token}` }
    });
};
